<template>
    <div class="votes">
        <div v-if="showQuorum"
            class="well"
        >
            <div class="votes__label">
                <div class="votes__label-text">{{ $t('global.poll.responseCollected') }}</div>

                <div :class="['votes__label-amount', `votes__label-amount--${votesCollectedColor}`]">
                    {{ poll.currentQuorumPercentage }}%
                </div>
            </div>

            <div class="votes__label votes__label--align-right">
                <div class="votes__label-amount">{{ votesRequiredPercentage }}%</div>

                <div class="votes__label-text">{{ $t('global.poll.responseRequired') }}</div>
            </div>

            <div class="votes__progress">
                <div :class="['votes__progress-bar', `votes__progress-bar--${votesCollectedColor}`]"
                    :style="{ width: poll.currentQuorumPercentage + '%' }"
                />
            </div>
        </div>

        <div class="well">
            <div v-for="(answer, index) in poll.answers"
                :key="index"
                class="answer"
            >
                <div class="votes__label">
                    <div class="answer__text">{{ getAnswerTranslation(answer) }}</div>
                    <div>{{ getAnswerVotePercentage(answer) }}%</div>
                </div>

                <div class="votes__progress">
                    <div class="votes__progress-bar"
                        :style="{ width: getAnswerVotePercentage(answer) + '%', backgroundColor: getAnswerColor(index) }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex';
import {
    getPollAnswerColor,
} from '@shared/utils/poll-colors.js';

export default {
    name: 'poll-vote-distribution',
    props: {
        poll: {
            type: Object,
            default: () => ({}),
        },
        showQuorum: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['getTranslatedStr']),

        votesCollected() {
            return this.poll.currentQuorumPercentage / this.votesRequiredPercentage;
        },
        votesCollectedColor() {
            if (this.votesCollected <= 0.5) {
                return 'red';
            }

            if (this.votesCollected < 1) {
                return 'amber';
            }

            return 'green';
        },
        votesRequiredPercentage() {
            return this.poll.quorum * 100;
        },
    },
    methods: {
        getAnswerTranslation(answer) {
            return this.getTranslatedStr(answer, 'answer', answer.answer);
        },
        getAnswerVotePercentage(answer) {
            const amount = Number(answer.votePercentage);

            if (amount === 0) {
                return 0;
            }

            return Number.isInteger(amount)
                ? amount
                : Number(amount.toFixed(2));
        },
        getAnswerColor(index) {
            return getPollAnswerColor(index);
        },
    },
};
</script>

<style lang="scss" scoped>
.votes {
    .well {
        display: flex;
        flex-wrap: wrap;
    }

    &__label {
        flex: 1;
        display: flex;
        font-size: 1.3rem;
        font-weight: bold;

        &--align-right {
            flex-direction: row-reverse;
        }

        &-text {
            width: min-content;

            @include min-width(md) {
                width: auto;
            }
        }

        &-amount {
            margin-left: 1rem;

            &--green {
                color: $lima-color;
            }

            &--red {
                color: $monza-color;
            }

            &--amber {
                color: $casablanca-color;
            }
        }

        & + .votes__label {
            margin-left: 1rem;
        }
    }

    &__progress {
        margin-top: 1rem;
        height: 0.5rem;
        width: 100%;
        background-color: $athens-gray-color;
        border-radius: 1rem;
        position: relative;

        &-bar {
            position: absolute;
            left: 0;
            height: 0.5rem;
            border-radius: 1rem;

            &--green {
                background-color: $lima-color;
            }

            &--red {
                background-color: $monza-color;
            }

            &--amber {
                background-color: $casablanca-color;
            }
        }
    }
}

.answer {
    width: 100%;
    display: flex;
    flex-direction: column;

    &__text {
        flex: 1;
    }

    & + .answer {
        margin-top: 3rem;
    }
}
</style>